const THRESHOLD_ATTRIBUTE_KEY = 'Prezent od';
const THRESHOLD_REQUIRED_PRODUCT_KEY = '_gift_for';
const THRESHOLD_REQUIRED_QUANTITY_KEY = '_gift_quantity';

class FomoWidget {
  constructor(minutes, productId, widgetId) {
    this.periodMs = minutes * 60 * 1000;
    this.giftProductId = productId;
    this.widgetId = widgetId;

    this._wasModalOpened = this.getLocalStorageDate('was-modal-opened');
    this._wasGiftAdded = this.getLocalStorageDate('was-added');
    this._startedAt = this.getLocalStorageDate('start-date');
    this._isActive = true;

    this.counterModal = document.getElementById('free-products-fomo-counter-modal');
    this.counterWidget = document.getElementById('free-products-fomo-counter');
    this.widget = document.getElementById('free-products-fomo');
    this.addBtn = this.widget.querySelector('.btn.btn--primary-1');
    this.modal = null;

    this.checkIsInitialized();
    setTimeout(this.tryToOpenModal.bind(this), 10_000);
    this.setListeners();
    this.initialModal();
  }

  get wasModalOpened() {
    return this._wasModalOpened;
  }
  set wasModalOpened(wasOpened) {
    this._wasModalOpened = !!wasOpened;
    this.setLocalStorageDate(!!wasOpened, 'was-modal-opened');
  }

  get isActive() {
    return this._isActive;
  }
  set isActive(isActive) {
    if (this.wasGiftAdded) return (this._isActive = false);
    if (!isActive) this.closeModal();
    if (this.widget && !isActive && this.startedAt) this.destroyWidget();
    this._isActive = isActive;
    this.widget.classList[isActive ? 'remove' : 'add']('!hidden');
  }

  get startedAt() {
    return this._startedAt;
  }
  set startedAt(date) {
    this._startedAt = date;
  }

  get wasGiftAdded() {
    return this._wasGiftAdded;
  }
  set wasGiftAdded(wasAdded) {
    this._wasGiftAdded = this._wasGiftAdded ? true : wasAdded;
    if (wasAdded) {
      this.setLocalStorageDate(wasAdded, 'was-added');
      this.destroyWidget();
      this.isActive = false;
    }
  }

  openModal() {
    if (!this.modal || this.wasModalOpened) return;

    this.modal.classList.add('active');
    dataLayerPromise({ event: 'fomo_modal_show' });
    this.initialize();
  }

  closeModal() {
    if (!this.modal) return;
    this.modal.classList.remove('active');
  }
  initialModal() {
    const modal = document.getElementById('modal-fomo-gift');
    const closeElements = modal?.querySelectorAll('.modal-close, img');

    if (!modal) return;
    this.modal = modal;

    closeElements?.forEach((el) =>
      el.addEventListener('click', () => {
        modal.classList.remove('active');
        if (el.tagName.toLowerCase() === 'img') {
          dataLayerPromise({ event: 'fomo_modal_button_click' });
        }
      })
    );
  }

  checkIsGiftAdded() {
    if (!this.giftProductId) return;
    this.wasGiftAdded = Rebuy.SmartCart.cart.items.some(({ product }) => String(product?.id) === this.giftProductId);
  }

  setListeners() {
    if (this.addBtn) {
      this.addBtn.addEventListener('click', () => {
        setTimeout(this.destroyWidget.bind(this), 500);
      });
    }
    setTimeout(this.checkIsGiftAdded.bind(this), 500);
    document.addEventListener('rebuy:cart.change', () => setTimeout(this.checkIsGiftAdded.bind(this), 500));
    document.addEventListener('rebuy:cart.enriched', () => setTimeout(this.checkIsGiftAdded.bind(this), 500));
    document.addEventListener('rebuy:smartcart.show', this.showWidgetEvent.bind(this));
  }

  showWidgetEvent() {
    if (this.isActive) {
      dataLayerPromise({ event: 'fomo_widget_show' });
    } else {
      document.removeEventListener('rebuy:smartcart.show', this.showWidgetEvent.bind(this));
    }
  }

  tryToOpenModal() {
    if (window.innerWidth > 768) return;

    const { remaining } = this.isTimeValid();

    if (this.wasModalOpened) return;
    if (this.isActive && remaining < 30_000) return;
    if (Rebuy?.SmartCart?.cart?.items && Rebuy.SmartCart.cart.items?.length > 0) return;

    this.openModal();
  }

  isTimeValid() {
    const clearMs = (ms) => Math.max(Math.ceil(ms / 1000) * 1000, 0);

    if (this.startedAt && new Date().getTime() - 7 * 86_400_000 > new Date(this.startedAt).getTime()) {
      this.reset();
    }

    return {
      isValid: new Date().getTime() < new Date(this.startedAt).getTime() + this.periodMs,
      remaining: clearMs(new Date(this.startedAt).getTime() + this.periodMs - new Date().getTime()),
    };
  }
  formatTime(ms, returnAsData) {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    if (returnAsData) {
      return { minutes, seconds };
    }

    return `${minutes} min : ${seconds.toString().padStart(2, '0')} sek`;
  }

  updateModalCounter({ minutes, seconds }) {
    if (!this.counterModal) return;

    const displays = this.counterModal.querySelectorAll('.fomo-counter-display');
    if (!displays.length) return;

    const minStr = String(minutes).padStart(2, '0');
    const secStr = String(seconds).padStart(2, '0');

    const [minTens, minOnes] = minStr;
    const [secTens, secOnes] = secStr;

    displays[0].textContent = minTens;
    displays[1].textContent = minOnes;
    displays[2].textContent = secTens;
    displays[3].textContent = secOnes;
  }
  updateCounters(time) {
    if (time > 0) {
      this.counterWidget.innerText = this.formatTime(time);
      this.updateModalCounter(this.formatTime(time, true));
    } else {
      this.counterWidget.innerText = '00 min : 00 sek';
      this.updateModalCounter({ minutes: 0, seconds: 0 });
    }
  }

  timerInterval() {
    const { isValid, remaining } = this.isTimeValid();
    this.updateCounters(remaining);
    if (this.isActive) {
      this.isActive = isValid;
    } else {
      clearInterval(this.intervalId);
    }
  }

  startCounting() {
    this.timerInterval();
    this.intervalId = setInterval(this.timerInterval.bind(this), 1000);
  }

  checkIsInitialized() {
    this.isActive = this.isTimeValid().isValid;
  }

  initialize() {
    const hasStarted = this.getLocalStorageDate('start-date');
    this.startCounting();

    if (hasStarted) {
      this.startedAt = hasStarted;
    } else {
      this.updateCounters(this.periodMs);
      const now = JSON.parse(JSON.stringify(new Date()));
      this.setLocalStorageDate(now, 'start-date');
      this.startedAt = now;
      this.isActive = true;
      this.wasModalOpened = true;
    }
  }

  setLocalStorageDate(date, key) {
    localStorage.setItem(this.widgetId + '-' + key, JSON.stringify(date));
  }

  getLocalStorageDate(key) {
    const storeDate = localStorage.getItem(this.widgetId + '-' + key);
    if (!storeDate) {
      return null;
    } else {
      return JSON.parse(storeDate);
    }
  }

  destroyWidget() {
    this.widget.remove();
  }

  reset() {
    localStorage.removeItem(`${this.widgetId}-start-date`);
    localStorage.removeItem(`${this.widgetId}-was-added`);
    localStorage.removeItem(`${this.widgetId}-was-modal-opened`);
  }
}

const setUpWidgetCarousels = () => {
  document.querySelectorAll('.cart-threshold-carousel').forEach((element) => {
    const id = element.getAttribute('id');
    new Swiper(`#${id}`, {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 12,
      activeIndex: 1,
      loop: false,
      navigation: {
        nextEl: `#next-${id}`,
        prevEl: `#prev-${id}`,
      },
    });
  });
};

const setUpWidgetAccordion = () => {
  const header = document.getElementById('free-products-header');
  const arrow = document.getElementById('free-products-arrow');
  const body = document.getElementById('free-products-body');

  header?.addEventListener('click', () => {
    if (body) body?.classList?.toggle('hidden');
    if (header) header?.querySelector('button')?.classList?.toggle('hidden');
    if (arrow) arrow?.classList?.toggle('rotate-180');

    const gtmAnalytics = () => {
      const widget = document.getElementById('free-products');
      const gifts = document.querySelectorAll('.cart-free-product');

      dataLayerPromise({
        event: 'cart_gratis_get',
      });

      if (widget && gifts) {
        gifts.forEach((gift) => {
          dataLayerPromise({
            event: 'cart_gratis_view',
            product_name: gift.getAttribute('data-product-name') ?? '',
            product_id: +gift.getAttribute('data-product-id') ?? null,
          });
        });
      }
    };
    if (body && !body.classList.contains('hidden')) {
      gtmAnalytics();
    }
  });
};

const handleAddGiftsAnalytics = () => {
  const giftProducts = document.querySelectorAll('.cart-free-product');
  giftProducts.forEach((product) => {
    product.querySelector('.btn')?.addEventListener('click', () => {
      dataLayerPromise({
        event: 'cart_gratis_add',
        product_name: product.getAttribute('data-product-name'),
        product_id: +product.getAttribute('data-product-id'),
        status: 'success',
      });
    });
  });
};

const handleWidgetViewAnalytics = () => {
  const cartJson = document.getElementById('SmartCartJson').textContent;
  const cartData = JSON.parse(cartJson);
  const { is_gift_widget_active, is_fomo_gift_widget_active } = cartData;
  if (is_gift_widget_active || (is_fomo_gift_widget_active && window?.fomoWidget?.isActive)) {
    dataLayerPromise({
      event: 'cart_gratis_view_get',
    });
  }
};

const collapseWidgetAccordion = () => {
  const header = document.getElementById('free-products-header');
  const arrow = document.getElementById('free-products-arrow');
  const body = document.getElementById('free-products-body');

  const cartData = JSON.parse(document.getElementById('SmartCartJson').textContent);
  if (!cartData.is_gift_widget_active) return;

  if (body) body?.classList?.add('hidden');
  if (header) header?.querySelector('button')?.classList?.remove('hidden');
  if (arrow) arrow?.classList?.add('rotate-180');
};

// const updateGiftProductPrice = () => {
//   const cartItems = Rebuy.SmartCart?.cart?.items || [];
//   const cartVariants = cartItems.flatMap((item) => item?.product?.variants);
//   const giftsInCart = document.querySelectorAll('.tag-gratis_product');
//
//   giftsInCart.forEach((giftsInCart) => {
//     const info = giftsInCart.querySelector('.rebuy-cart__flyout-item-info-first');
//     const variantId = +giftsInCart.getAttribute('data-variant');
//     const price = cartVariants.find((v) => v?.id === variantId)?.compare_at_price;
//
//     if (price && info) {
//       const formattedPrice = String(price).replace('.', ',') + ' zł';
//       info.setAttribute('data-price-content', formattedPrice);
//     }
//   });
// };

const updateGiftProductSelectIfVariantIsAdded = (select, allVariants) => {
  if (select && allVariants.length === 1 && +select.value !== allVariants[0].variant_id) {
    select.querySelectorAll('option').forEach((option) => {
      option.removeAttribute('selected');
      if (+option.value === allVariants[0].variant_id) {
        option.setAttribute('selected', '');
      }
    });
  }
};

const formatPriceForGifts = (price) => {
  return new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN',
  }).format(price);
};

const setProductButtonClickListener = (
  product,
  variantId,
  shouldGiftBeInCart,
  products,
  useDiscountedTotal,
  threshold
) => {
  const button = product.querySelector('button.btn');
  const buttons = [];

  const properties = useDiscountedTotal ? { [THRESHOLD_ATTRIBUTE_KEY]: formatPriceForGifts(threshold) } : undefined;

  products.forEach((product) => buttons.push(product.querySelector('button.btn')));

  button.onclick = () => {
    let id = variantId;
    if (product.querySelector('select')) {
      id = product.querySelector('select').value * 1;
    }
    if (shouldGiftBeInCart) {
      buttons.forEach((button) => (button.disabled = true));
      Rebuy.Cart.addItem({ quantity: 1, id, properties });
    }
  };
};

const buttonStateHandler = (element, isActive, text) => {
  element.querySelectorAll('button.btn, select').forEach((el) => {
    if (isActive) {
      el.removeAttribute('disabled');
      el.classList.remove('opacity-50');
    } else {
      el.setAttribute('disabled', 'disabled');
      el.classList.add('opacity-50');
    }
    if (el.tagName.toLowerCase() === 'button') el.innerText = text ?? 'DODAJ ZA 1 GROSZ';

    if (el.tagName.toLowerCase() === 'button' && text === 'DODANO INNY') {
      el.classList.add('isOtherAdded');
    } else if (el.classList.contains('isOtherAdded')) {
      el.classList.remove('isOtherAdded');
    }
  });
};

const productActiveStateHandler = (element, isActive, isAdded, allGiftsFromThreshold) => {
  if (isAdded) {
    element.classList.remove('opacity-60');
    allGiftsFromThreshold.forEach((item) => {
      item.classList.remove('opacity-60');
      setTimeout(() => buttonStateHandler(item, false, 'DODANO INNY'), 10);
    });
    setTimeout(() => buttonStateHandler(element, false, 'DODANO 🩷'), 20);
    return;
  }

  if (isActive) {
    element.classList.remove('opacity-60');
    buttonStateHandler(element, isActive);
  } else {
    element.classList.add('opacity-60');
    buttonStateHandler(element, isActive);
  }
};

const giftInCartHandler = (id, cartItems, shouldGiftBeInCart, gift, allVariantsOfGift) => {
  if (!gift && allVariantsOfGift.length === 0) return;

  if (allVariantsOfGift.length > 1) {
    allVariantsOfGift.forEach((variant) => variant.id !== id && Rebuy.Cart.removeItem(variant));
  }

  if (!shouldGiftBeInCart) {
    allVariantsOfGift.forEach(Rebuy.Cart.removeItem);
    return;
  }

  if (gift?.quantity >= 2) {
    Rebuy.Cart.decreaseItem(gift);
  }
};

const handleDigitalProductsInCart = () => {
  const cartItems = Rebuy.SmartCart?.cart?.items || [];

  const digitalProductsArr = cartItems?.filter((item) => {
    return item?.product?.tags?.includes('digital');
  });

  let digitalProductsTotalValue = 0;

  const digitalInformation = document.querySelector('.widget-digital-product-text');

  if (digitalProductsArr && digitalProductsArr.length > 0) {
    if (digitalInformation) digitalInformation.classList.remove('hidden');
    digitalProductsArr.forEach((item) => {
      digitalProductsTotalValue += item.original_price * item.quantity;
    });
  } else {
    if (digitalInformation) digitalInformation.classList.add('hidden');
  }

  return { digitalProductsTotalValue };
};

const handleUseDiscountedTotal = (threshold) => {
  const cartJson = document.getElementById('SmartCartJson').textContent;
  const cartData = JSON.parse(cartJson);
  const { use_discounted_total: total, use_discounted_total_for_fomo: fomo } = cartData;

  const { digitalProductsTotalValue } = handleDigitalProductsInCart();
  let shouldGiftBeInCart = (Rebuy.SmartCart.cart.original_total_price - digitalProductsTotalValue) / 100 >= threshold;

  if ((total || fomo) && Rebuy.SmartCart.cart.total_discount > 0) {
    shouldGiftBeInCart = (Rebuy.SmartCart.cart.total_price - digitalProductsTotalValue) / 100 >= threshold;
  }

  return { shouldGiftBeInCart, use_discounted_total: total || fomo };
};

const updateEveryProductHandler = () => {
  const products = document.querySelectorAll('.cart-free-product');

  products.forEach((product) => {
    const cartItems = Rebuy.SmartCart.cart.items || [];
    const select = product.querySelector('select');
    const threshold = product.getAttribute('data-threshold');
    const variantId = product.getAttribute('data-variant-id') * 1;
    const productId = product.getAttribute('data-product-id') * 1;
    const allVariants = cartItems.filter((item) => item?.product?.id === productId);
    const gift = cartItems.find((item) => item.variant_id === variantId);
    const isGiftInCart = allVariants.length > 0;

    const { shouldGiftBeInCart, use_discounted_total } = handleUseDiscountedTotal(threshold);
    const allGiftsFromThreshold = document.querySelectorAll(`[data-threshold="${threshold}"]`);

    updateGiftProductSelectIfVariantIsAdded(select, allVariants);
    productActiveStateHandler(product, shouldGiftBeInCart, isGiftInCart, allGiftsFromThreshold);
    giftInCartHandler(variantId, cartItems, shouldGiftBeInCart, gift, allVariants);
    setProductButtonClickListener(
      product,
      variantId,
      shouldGiftBeInCart,
      allGiftsFromThreshold,
      use_discounted_total,
      threshold
    );
  });
};

const handleCalculateThresholdMissingAmount = () => {
  document.querySelectorAll('.cart-threshold').forEach((element) => {
    const threshold = +element.getAttribute('data-threshold');

    const { use_discounted_total } = handleUseDiscountedTotal(threshold);
    const { digitalProductsTotalValue } = handleDigitalProductsInCart();
    let missing = '';
    if (use_discounted_total) {
      missing = threshold - (Rebuy.SmartCart.cart.total_price - digitalProductsTotalValue) / 100;
    } else {
      missing = threshold - (Rebuy.SmartCart.cart.original_total_price - digitalProductsTotalValue) / 100;
    }

    const display = element.querySelector('.cart-threshold-display');
    if (!display) return;

    if (missing > 0) {
      display.innerHTML = `. Brakuje Ci tylko <strong>${missing.toFixed(2).replace('.', ',')} zł!</strong>`;
    } else {
      display.innerHTML = '';
    }
  });
};

const getAllActiveGifts = () => {
  const cartJson = document.getElementById('SmartCartJson').textContent;
  const cartData = JSON.parse(cartJson);

  const widgetsKeys = ['multi_threshold_gifts'];

  const { active_gifts, active_gifts_thresholds } = cartData;

  const additionalGifts = widgetsKeys.flatMap((key) => {
    return cartData[key].details.active_gifts;
  });

  const additionalThresholds = widgetsKeys.flatMap((key) => {
    return cartData[key].details.active_gifts_thresholds;
  });

  return [
    [...active_gifts, ...additionalGifts],
    [...active_gifts_thresholds, ...additionalThresholds],
  ];
};

const handleDeleteProductAfterPromoExpiry = () => {
  const cartJson = document.getElementById('SmartCartJson').textContent;
  const cartData = JSON.parse(cartJson);
  const cartItems = Rebuy.SmartCart?.cart?.items || [];
  const { all_gifts_products } = cartData;
  const [active_gifts] = getAllActiveGifts();

  if (!cartData || !all_gifts_products) return;
  if (Array.isArray(all_gifts_products)) {
    const productsIdsToDelete = all_gifts_products.filter((id) => !active_gifts.includes(id));
    const cartItemsToDelete = cartItems.filter((item) => productsIdsToDelete.includes(item.product?.id.toString()));
    cartItemsToDelete.forEach(Rebuy.SmartCart.removeItem);
  }
};

const handleRemoveGiftFromCartAfterAmountIsBelowTheThreshold = () => {
  const { active_gifts, active_gifts_thresholds } = getAllActiveGifts();

  const cartItems = Rebuy.SmartCart?.cart?.items || [];
  cartItems.forEach((cartItem) => {
    if (!active_gifts) return;
    if (!active_gifts.includes(String(cartItem.product?.id))) return;

    const threshold = active_gifts_thresholds[active_gifts.indexOf(String(cartItem.product?.id))];
    const { digitalProductsTotalValue } = handleDigitalProductsInCart();
    let shouldGiftBeInCart = (Rebuy.SmartCart.cart.original_total_price - digitalProductsTotalValue) / 100 >= threshold;

    if (!shouldGiftBeInCart) {
      Rebuy.SmartCart.removeItem(cartItem);
    }
  });
};

const addAutomaticGiftToCartHandler = () => {
  const gift_product = document.getElementById('SmartCartJson');
  const giftProductData = gift_product.textContent;
  const giftProductJson = JSON.parse(giftProductData);

  let giftID = '';
  let gratis_threshold = giftProductJson.gratis_product_threshold;
  let gratis_product_redirect_url = giftProductJson.cart_gratis_product_redirect_url;

  if (giftProductJson && giftProductJson.gratis_product && gratis_threshold) {
    let threshold = JSON.parse(giftProductJson.gratis_product_threshold);

    const product = giftProductJson.gratis_product;
    giftID = product.variants[0].id;

    let cartItems = Rebuy.SmartCart.cart.items || [];
    const gift = cartItems.find((item) => item.variant_id === giftID);

    const { digitalProductsTotalValue, use_discounted_total } = handleDigitalProductsInCart();
    let shouldGiftBeInCart = (Rebuy.SmartCart.cart.original_total_price - digitalProductsTotalValue) / 100 >= threshold;

    if (!shouldGiftBeInCart) {
      if (gift) Rebuy.SmartCart.removeItem(gift);
      return;
    }

    const giftExisted = cartItems.some((i) => i.variant_id === giftID);

    if (gift && (gift.quantity >= 2 || !shouldGiftBeInCart)) {
      Rebuy.Cart.decreaseItem(gift);
    }

    const anyGiftExisted = cartItems.some((item) => {
      return item?.product?.tags?.includes('gratis_product');
    });

    const physicalProducts = cartItems.filter((item) => {
      return !item?.product?.tags?.includes('tag-ebook');
    });

    if (physicalProducts.length === 0) {
      if (gift) Rebuy.SmartCart.removeItem(gift);
      return;
    }

    const properties = use_discounted_total ? { [THRESHOLD_ATTRIBUTE_KEY]: formatPriceForGifts(threshold) } : undefined;

    const redirectProps = {
      _redirectTo: gratis_product_redirect_url,
    };

    if (!giftExisted && !anyGiftExisted && shouldGiftBeInCart) {
      Rebuy.Cart.addItem({
        id: giftID,
        quantity: 1,
        properties: {
          ...(!!gratis_product_redirect_url && redirectProps),
          ...(!!properties && properties),
        },
      });
    }
  }
};

const initializeFomoWidget = () => {
  const getFomoWidget = document.getElementById('free-products-fomo');
  if (getFomoWidget) {
    const minutes = getFomoWidget.getAttribute('data-minutes');
    const widgetId = getFomoWidget.getAttribute('data-widget-id');
    const productId = getFomoWidget.getAttribute('data-gift-product-id');
    window.yk_fomo = new FomoWidget(minutes, productId, widgetId);
  }
};

document.addEventListener('rebuy:smartcart.ready', () => {
  setUpWidgetCarousels();
  handleAddGiftsAnalytics();
  setUpWidgetAccordion();
  setTimeout(initializeFomoWidget, 100);
  setTimeout(updateEveryProductHandler, 100);
  setTimeout(handleDeleteProductAfterPromoExpiry, 100);
  setTimeout(handleCalculateThresholdMissingAmount, 100);
  setTimeout(handleRemoveGiftFromCartAfterAmountIsBelowTheThreshold, 100);
});

document.addEventListener('rebuy:cart.change', () => {
  setTimeout(updateEveryProductHandler, 300);
  setTimeout(handleDeleteProductAfterPromoExpiry, 300);
  setTimeout(handleCalculateThresholdMissingAmount, 300);
  setTimeout(handleRemoveGiftFromCartAfterAmountIsBelowTheThreshold, 300);
});

document?.addEventListener('rebuy:smartcart.show', () => {
  handleWidgetViewAnalytics();
  collapseWidgetAccordion();
  if (window.yk_fomo) window.yk_fomo.initialize();
});
